import React from "react";
import styles from './List.module.css';

const List = (props) => {
  const classes = " " + props.className;

  return <div className={styles.list + classes} onClick={props.onClick}>{props.children}</div>;
};

export default List;
